import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RsfHoldPointDashboardRow } from './rsf-hold-point-dashboard.models';

@Injectable({ providedIn: 'root' })
export class RsfHoldPointDashboardService {
  private readonly api = `${environment.urls.baseApiUrl}/RSF/HoldPointDashboard`;
  private selectedSerialNo: string | null = null;

  constructor(private readonly http: HttpClient) { }

  /** Loads open RSFs and their persisted hold-point signature progress. */
  getDashboard(): Observable<RsfHoldPointDashboardRow[]> {
    return this.http.get<RsfHoldPointDashboardRow[]>(this.api);
  }

  /**
   * Stores the RSF selection for the next Hold Points page navigation.
   * @param serialNo Serial number to highlight, or null when no RSF is selected.
   */
  setSelectedSerialNo(serialNo: string | null | undefined): void {
    this.selectedSerialNo = serialNo || null;
  }

  /**
   * Returns and clears the RSF selection passed from the RSF page.
   * @returns The selected serial number, if one was provided.
   */
  consumeSelectedSerialNo(): string | null {
    const serialNo = this.selectedSerialNo;
    this.selectedSerialNo = null;
    return serialNo;
  }
}
